import { css } from '@emotion/core';
import { shadow, tokens } from '@domain-group/fe-brary';
import { paginatorLargeBreakpoint } from './variables';
var neutral = tokens.colors.neutral;
export var variables = {
  '--paginator-border-radius': '12px',
  '--paginator-border-width': '1px'
};
export var mobileOnly = /*#__PURE__*/css("@media (min-width:", paginatorLargeBreakpoint, "){display:none;}");
export var desktopOnly = /*#__PURE__*/css("display:none;@media (min-width:", paginatorLargeBreakpoint, "){display:inline-block;}");
export var generateColors = state => /*#__PURE__*/css("color:", neutral.medium[state], ";background-color:", neutral.surface[state], ";border-color:", neutral.trim[state], ";");
export var generateStatesColors = /*#__PURE__*/css(generateColors('default'), ";:active{", generateColors('pressed'), "}:hover{", generateColors('hover'), "}:focus{", generateColors('selected'), "}:disabled,:disabled:hover,:disabled:focus{", generateColors('disabled'), "}");
export var boxShadow = /*#__PURE__*/css("box-shadow:", shadow(tokens.shadows.elevation1), ";");